import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

type UseAddUserToGroupForm = () => UseFormReturn;

export const useAddUserToGroupForm: UseAddUserToGroupForm = () => {
  const validationSchema = yup.object().shape({
    group: yup.object().required('Select a group').shape({
      label: yup.string(),
      value: yup.string(),
    }),
  });

  return useForm({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });
};
